import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/auth/clients/accept-invitation/page.tsx")